import React from "react";

const SingleStockAnalysisIcon = (props: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="#667085"
      className="size-6"
      {...props}
    >
      {/* Chart base lines */}
      <line x1="3" y1="20" x2="3" y2="4" strokeLinecap="round" />
      <line x1="3" y1="20" x2="21" y2="20" strokeLinecap="round" />

      {/* Rising trend line */}
      <polyline
        points="5,17 9,13 13,15 17,8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Highlighted single data point */}
      <circle cx="17" cy="8" r="2.5" strokeWidth={1.5} />
      <circle cx="17" cy="8" r="0.75" fill="#667085" stroke="none" />
    </svg>
  );
};

export default SingleStockAnalysisIcon;
